import { useCallback, useEffect, useState } from "react";
import { lastMinuteService } from "../../services/lastMinuteService";

// Browse feed with server-side filters. Shared by the agent view (M2) and the club
// browse (M3). `filters` is a plain object of query params (category, listing_type,
// urgency, ready_to_fly, short_term, salary_max, mv_min, mv_max). Privacy — current
// club exclusion, reveal-based naming, blacklist — is enforced server-side.
export const useLastMinuteFeed = (filters = {}) => {
  const [listings, setListings] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Stable key so the effect only refires on a real filter change.
  const filterKey = JSON.stringify(filters);

  const fetch = useCallback(
    async (signal) => {
      setLoading(true);
      const params = {};
      Object.entries(filters).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "" && v !== false) params[k] = v;
      });
      const res = await lastMinuteService.getFeed(params, signal);
      if (res.success) {
        setListings(res.data);
        setCount(res.count);
        setError(null);
      } else {
        setError(res.error);
      }
      setLoading(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterKey],
  );

  useEffect(() => {
    const controller = new AbortController();
    fetch(controller.signal).catch(() => {});
    return () => controller.abort();
  }, [fetch]);

  return { listings, count, loading, error, refetch: fetch };
};

export default useLastMinuteFeed;
